import { ref, computed } from "vue";
import { defineStore, storeToRefs } from "pinia";

import { useCurrentUserStore } from "@stores/currentUser";

export const useGeneralSetupJobStore = defineStore("generalSetupJob", () => {
  // imported stores
  const currentUserStore = useCurrentUserStore();
  const { isAdmin } = storeToRefs(currentUserStore);

  const fields = ref([
    { name: "job_name", label: "Name" },
    { name: "job_type", label: "Job Type" },
    { name: "job_cron", label: "Cron" },
    { name: "job_timezone", label: "Timezone" },
  ]);

  const currentFields = computed(() => (isAdmin.value ? fields.value : []));

  return {
    currentFields,
  };
});
